import { whatIfInnerSelector, whatIfOrDefaultSelector } from '../../WhatIfsSelector';

export const selectRothConversions = (state, props) =>
  whatIfInnerSelector(state, props).Conversions || [];

export const selectRothConversionOptions = state => {
  const whatIf = whatIfOrDefaultSelector(state);

  return whatIf.Options
    ? {
        ...whatIf.Options,
        FromAccounts: (whatIf.Options.FromAccounts || []).map(
          ({ Value, Label, Balance, RetirementYear, Owner }) => ({
            value: Value,
            label: Label,
            balance: Balance,
            retirementYear: RetirementYear,
            owner: Owner,
          }),
        ),
        ToAccounts: (whatIf.Options.ToAccounts || []).map(({ Value, Label, Balance, Owner }) => ({
          value: Value,
          label: Label,
          balance: Balance,
          owner: Owner,
        })),
        Years: (whatIf.Options.Years || []).map(({ Value, Label }) => ({
          value: Value,
          label: Label,
        })),
        TaxBrackets: (whatIf.Options.TaxBrackets || []).map(({ Value, Label }) => ({
          value: Value,
          label: Label,
        })),
      }
    : {};
};
